module.exports = __webpack_public_path__ + "static/media/test-dark.8a0c3227.svg";